<template>
  <div
    class="border-1 rounded-xl shadow-md"
    :class="{
      'bg-indigo-200 col-span-1 row-span-2 md:grid md:grid-rows-2 md:grid-cols-1 md:h-full':
        position === 3,
      'bg-white': position < 3,
      'md:grid md:grid-cols-2 md:h-full col-span-2': position == 2,
    }"
  >
    <div
      v-if="position > 1"
      class="relative hidden md:flex justify-center md:row-start-1 md:row-span-1 md:col-span-1"
      :class="{
        'bg-indigo-200': position === 3,
      }"
    >
      <illustration
        name="cartographie"
        class="absolute bottom-9 xl:bottom-20 transform scale-110 xl:scale-150"
      />
    </div>
    <div
      class="py-10 md:p-5 xl:p-8 flex flex-col space-y-5 md:space-y-2 lg:space-y-5 2xl:space-y-10"
      :class="{
        'xl:row-start-2 xl:row-span-1 xl:col-span-1 m-1.5 bg-white border rounded-xl z-10':
          position === 3,
      }"
    >
      <div class="text-2xl md:text-xl xl:text-2xl text-center">
        {{
          cartographyDatas.type == 'multi3'
            ? evaluationName
            : cartographyDatas.type == 'multi1' && evaluationName == 'current'
            ? cartographyDatas.values[0].title
            : cartographyDatas.type == 'multi1' && evaluationName == 'history'
            ? cartographyDatas.values[0].title
            : cartographyDatas.title
        }}
      </div>

      <router-link
        :to="{ name: 'Cartoindcompperso', params: { id: user.id } }"
        class="flex items-center justify-center h-full"
      >
        <div
          v-if="
            cartographyDatas &&
            Object.keys(cartographyDatas).length > 0 &&
            backdoor
          "
          class="flex justify-center md:w-11/12 md:h-10/12 lg:w-full xl:h-full 2xl:h-auto"
        >
          <!-- BEGIN Compétences clés & informatique -->
          <!-- Case there is a current evaluation -->
          <radar
            v-if="cartographyDatas.type == 'multi3'"
            id-chart="multi3"
            title=""
            :labels="cartographyDatas.labels"
            :values="cartographyDatas.values"
            :max="cartographyDatas.max"
            height="250"
            :maintain-aspect-ratio="false"
          />
          <pie
            v-if="['clea', 'clea_num'].includes(cartographyDatas.type)"
            id-chart="clea"
            title=""
            :labels="cartographyDatas.longLabels"
            :values="cartographyDatas.datas"
            :colors="cartographyDatas.colors"
            position-legend="bottom"
            height="250"
          />
          <!-- END Compétences clés & informatique -->

          <!-- BEGIN Compétences linguistiques -->
          <radar
            v-if="
              cartographyDatas.type == 'multi1' && evaluationName == 'current'
            "
            :id-chart="'langue'"
            title=""
            :labels="cartographyDatas.labels"
            :values="cartographyDatas.values[0].value"
            :max="cartographyDatas.max"
            height="250"
            :maintain-aspect-ratio="false"
          />
          <radar
            v-if="
              cartographyDatas.type == 'multi1' && evaluationName == 'history'
            "
            :id-chart="'langue'"
            title=""
            :labels="cartographyDatas.labels"
            :values="cartographyDatas.values"
            :max="cartographyDatas.max"
            height="250"
            :maintain-aspect-ratio="false"
          />
          <!-- END Compétences linguistiques -->

          <!-- BEGIN Compétences socio pro -->
          <radar
            v-if="cartographyDatas.type == 'multi2'"
            :id-chart="'compsociopro'"
            title=""
            :labels="cartographyDatas.labels"
            :values="cartographyDatas.values"
            :max="cartographyDatas.max"
            height="250"
            :maintain-aspect-ratio="false"
          />
          <!-- END Compétences socio pro -->

          <!-- BEGIN Compétences pro -->
          <radar
            v-if="cartographyDatas.type == 'pro'"
            :id-chart="'comppro'"
            title=""
            :labels="cartographyDatas.labels"
            :values="cartographyDatas.values"
            :max="cartographyDatas.max"
            height="250"
            :maintain-aspect-ratio="false"
          />
          <!-- END Compétences pro -->
        </div>
        <div v-else class="flex flex-col justify-between h-full">
          <p class="text-center text-2xl md:text-xl xl:text-2xl font-normal">
            Cartographie individuelle
          </p>
          <div class="flex flex-col justify-center h-full">
            <p class="text-center text-gray-600">Aucune donnée à afficher</p>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Illustration from './../Illustration';
import Radar from './../Charts/Radar';
import Pie from './../Charts/Pie';
import Constants from './../../constants';

export default {
  components: {
    Illustration,
    Radar,
    Pie,
  },

  props: {
    position: {
      type: Number,
      default: 3,
    },
  },

  async created() {
    if (this.role == Constants.ROLE_BENEFICIAIRE || this.$freeParticulier()) {
      await this.load_infos_pass(this.user.id);
      await this.load_evaluations();
    }
  },

  data() {
    return {
      evaluationName: '',
      constants: Constants,
    };
  },

  methods: {
    ...mapActions({
      load_evaluations: 'cartographiesIndividuelles/load_evaluations',
      load_infos_pass: 'cartographiesIndividuelles/load_infos_pass',
    }),

    color(c) {
      if (c == 'indigo') {
        return '#3A18D1';
      } else if (c == 'pink') {
        return '#FF1C80';
      } else if (c == 'elevenColors') {
        return [
          '#ff1c80',
          '#E61B89',
          '#D31B91',
          '#C01A99',
          '#AD1AA1',
          '#9A19A9',
          '#8619B1',
          '#7319B9',
          '#5B18C3',
          '#3A18D1',
          '#919AA6',
        ];
      } else if (c == 'tenColors') {
        return [
          '#ff1c80',
          '#E21B8B',
          '#CA1A95',
          '#B21A9F',
          '#9A19A9',
          '#8219B3',
          '#6A18BD',
          '#5B18C3',
          '#3A18D1',
          '#919AA6',
        ];
      } else if (c == 'nineColors') {
        return [
          '#ff1c80',
          '#DD1B8D',
          '#C01A99',
          '#A31AA5',
          '#8619B1',
          '#6A18BD',
          '#5618C5',
          '#3A18D1',
          '#919AA6',
        ];
      } else if (c == 'eightColors') {
        return [
          '#ff1c80',
          '#D81B8F',
          '#B61A9D',
          '#9519AB',
          '#7319B9',
          '#5B18C3',
          '#3A18D1',
          '#919AA6',
        ];
      }
    },
  },

  computed: {
    ...mapGetters({
      listModules: 'template/listModulesPages',
      role: 'auth/role',
      permissions: 'auth/permissions',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      user: 'auth/user',
      backdoor: 'app/backdoor',
    }),

    cartographyDatas() {
      if (
        Object.keys(
          (this.neopassDatas || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
          ] || {}
        ).length > 0 &&
        (this.$can('compcle_read') || this.$can('compcle_edit'))
      ) {
        this.evaluationName = 'Compétences clés';
        return this.neopassDatas[Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES];
      }
      if (
        (
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
          ] || []
        ).length > 0 &&
        Object.keys(
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
          ][0] || {}
        ).length > 0 &&
        (this.$can('compcle_read') || this.$can('compcle_edit'))
      ) {
        this.evaluationName = 'Compétences clés';
        return this.listEvaluations[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
        ][0];
      }
      if (
        Object.keys(
          (this.neopassDatas || {})[
            Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
          ] || {}
        ).length > 0 &&
        (this.$can('informatique_read') || this.$can('informatique_edit'))
      ) {
        this.evaluationName = 'Informatique';
        return this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ];
      }
      if (
        (
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
          ] || []
        ).length > 0 &&
        Object.keys(
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
          ][0] || {}
        ).length > 0 &&
        (this.$can('informatique_read') || this.$can('informatique_edit'))
      ) {
        this.evaluationName = 'Informatique';
        return this.listEvaluations[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ][0];
      }
      if (
        Object.keys(
          (this.neopassDatas || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
          ] || {}
        ).length > 0 &&
        (this.$can('langue_read') || this.$can('langue_edit'))
      ) {
        this.evaluationName = 'current';
        return this.neopassDatas[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
        ];
      }
      if (
        (
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
          ] || []
        ).length > 0 &&
        Object.keys(
          (this.listEvaluations || {})[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
          ][0] || {}
        ).length > 0 &&
        (this.$can('langue_read') || this.$can('langue_edit'))
      ) {
        this.evaluationName = 'history';
        let evaluations =
          this.listEvaluations[
            Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
          ];

        return evaluations[1].filter(
          (h) => h.date_fin_eval == evaluations[0]
        )[0];
      }
      if (
        Object.keys(
          (this.neopassDatas || {})[
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
          ] || {}
        ).length > 0 &&
        (this.$can('compsocio_read') || this.$can('compsocio_edit'))
      ) {
        if (
          Object.values(
            this.neopassDatas[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
            ]
          )[0].length > 0
        ) {
          this.evaluationName = 'current';
          return Object.values(
            this.neopassDatas[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
            ]
          )[0][0];
        }
      }
      if (
        Object.keys(
          (this.listEvaluations || {})[
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
          ] || {}
        ).length > 0 &&
        (this.$can('compsocio_read') || this.$can('compsocio_edit'))
      ) {
        if (
          Object.values(
            this.listEvaluations[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
            ]
          )[0].length > 0
        ) {
          this.evaluationName = 'history';
          let evaluations = Object.values(
            this.listEvaluations[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO
            ]
          )[0][0];

          return evaluations[1].filter(
            (h) => h.date_fin_eval == evaluations[0]
          )[0];
        }
      }
      if (
        Object.keys(
          (this.neopassDatas || {})[
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
          ] || {}
        ).length > 0 &&
        (this.$can('comppro_read') || this.$can('comppro_edit'))
      ) {
        if (
          Object.values(
            this.neopassDatas[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
            ]
          )[0].length > 0
        ) {
          this.evaluationName = 'current';
          return Object.values(
            this.neopassDatas[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
            ]
          )[0][0];
        }
      }
      if (
        Object.keys(
          (this.listEvaluations || {})[
            Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
          ] || {}
        ).length > 0 &&
        (this.$can('comppro_read') || this.$can('comppro_edit'))
      ) {
        if (
          Object.values(
            this.listEvaluations[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
            ]
          )[0].length > 0
        ) {
          this.evaluationName = 'history';
          let evaluations = Object.values(
            this.listEvaluations[
              Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
            ]
          )[0][0];

          return evaluations[1].filter(
            (h) => h.date_fin_eval == evaluations[0]
          )[0];
        }
      }
      return {};
    },
  },
};
</script>
